import { Controller } from "@hotwired/stimulus";

// Group form controller - handles UI interactions that don't require server-side computation.
// Date calculations have been moved to the backend (GroupFormBuilder.apply_computed_dates!)
// and are triggered via form reload on field changes.
//
// Note: setApplyDefaultsAndSubmit has been moved to reload_form_controller.js
// This allows non-backoffice controllers (e.g., reviewer) to use this form
// without triggering server reloads they don't have access to.
export default class extends Controller {
  // Toggle workshop item collapse visibility
  changeGroupItemEnabled(event) {
    document
      .getElementById(`collapse-${event.target.dataset.itemId}`)
      .classList.toggle("d-none");
  }
}
